import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import White from '../../../Assets/images/white-bg.avif'
import { setAdvance, setBooking, setDelivery, setPickup, setStep } from "../../../Reducer/bookingSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { toast } from "react-toastify";
import Compressor from 'compressorjs';
import Handler from "../../../Helpers/Components/Handler";
import Modal from "../../../Helpers/Components/Modal";

const Payment = (props) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [chosen, setChosen] = useState()
    const [proof, setProof] = useState()
    const booking = useSelector(state => state?.booking?.booking)
    const setSteps = () => {
        dispatch(setStep(1))
    }
    const handleChange = (e) => {
        dispatch(setBooking({ [e.target.name]: e.target.value }))
    }
    const handleNext = async () => {
        let bal = Number(booking?.balancePaid || 0) + Number(booking?.advance?.amount || 0);
        if ((!booking?.rentalFee || Number(booking?.rentalFee) <= 0)) {
            toast.error("Cost per day is required");
        } else if ((Number(booking?.offerPerDay) < 0)) {
            toast.error("Invalid Offer per day");
        } else if (((Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0)) * booking?.totalDays) <= 0) {
            toast.error("Invalid Offer given");
        } else if (Number(booking?.rentalFee || 0) / 2 < Number(booking?.halfDayOffer)) {
            toast.error("Half day offer is invalid")
        } else if ((Number(booking?.deliveryDetails?.price) < 0)) {
            toast.error("Invalid Delivery Charge");
        } else if ((Number(booking?.pickupDetails?.price) < 0)) {
            toast.error("Invalid Pickup Charge");
        } else if ((Number(booking?.securityDeposit) < 0)) {
            toast.error("Invalid Security Deposit");
        } else if (!Number(booking?.advance?.amount) || (Number(booking?.advance?.amount) <= 0)) {
            toast.error("Invalid Advance Paid");
        } else if ((!booking?.advance?.mode)) {
            toast.error("Advance paid mode is required");
        } else if ((Number(bal) < Number(booking?.advance?.amount || 0))) {
            toast.error("Advance paid should be less than balance to be paid");
        } else {
            const data = {
                rentalFee: Number(booking?.rentalFee) || 0,
                offerPerDay: Number(booking?.offerPerDay) || 0,
                halfDayOffer: booking?.point === 0.5 ? booking?.halfDayOffer : 0,
                deliveryDetails: { price: booking?.deliveryDetails?.price || 0 },
                pickupDetails: { price: booking?.pickupDetails?.price || 0 },
                advance: booking?.advance,
                securityDeposit: booking?.securityDeposit || 0
            }
            setLoading(true);
            const response = await Handler({ method: 'patch', url: `/booking/details/second/update/${props?.bookingId}`, data })
            setLoading(false)
            if (response?.success) {
                dispatch(setStep(3))
            } else {
                toast.error(response?.message)
            }
        }

    }
    const checkFileSize = async (file, fieldName) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            setLoading(true)
            const response = await Handler({ method: 'patch', url: `/booking/details/advance/photo/${props?.bookingId}`, data: { advancePhoto: file }, headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                dispatch(setAdvance({ photo: response?.data }))
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    };
    const compressImage = (file, fieldName) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result, fieldName);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0], [event.target.name]);
        }
    };
    useEffect(() => {
        let totalAmount =
            ((Number(booking?.rentalFee || 0) -
                Number(booking?.offerPerDay || 0)) * (booking?.totalDays || 0)) +
            Number(booking?.deliveryDetails?.price || 0) + Number(booking?.pickupDetails?.price || 0) +
            Number(booking?.securityDeposit || 0)
        totalAmount += Number(booking?.point) === 0.5 ? (Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0) : 0
        dispatch(setBooking({ balancePaid: totalAmount - Number(booking?.advance?.amount || 0), totalAmount }));
    }, [booking?.rentalFee, booking?.offerPerDay, booking?.totalDays, booking?.deliveryDetails, booking?.pickupDetails, booking?.securityDeposit, booking?.point, booking?.halfDayOffer, booking?.advance]);
    return (
        <React.Fragment>
            <Modal header="Photo" onShow={proof} toggle={() => setProof(false)} overlayToggle={() => setProof(false)}>
                <div className="modalPhoto">
                    <img src={chosen || White} alt="Proof" />
                </div>
            </Modal>
            <div className="fw-bold mb-3 text-center">{Number(booking?.totalDays || 0) + Number(booking?.point || 0)} Day Trip</div>
            {
                booking?.point === 0.5 ?
                    <div className="row">
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="halfDayOffer" className="form-label"> Half Day Offer </label>
                                <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleChange(e) } }} name="halfDayOffer" id="halfDayOffer" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.halfDayOffer || ""} />
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="halfRent" className="form-label"> Half Day Rent </label>
                                <input name="halfRent" id="halfRent" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.rentalFee ? (Number(booking?.rentalFee) / 2) - Number(booking?.halfDayOffer || 0) : ""} />
                            </div>
                        </div>
                    </div> : ""
            }
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="rentalFee" className="form-label"> Cost Per Day </label>
                        <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleChange(e) } }} name="rentalFee" id="rentalFee" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.rentalFee || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="offerPerDay" className="form-label"> Offer Per Day </label>
                        <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleChange(e) } }} name="offerPerDay" id="offerPerDay" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.offerPerDay || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="totalCost" className="form-label"> Per Day Cost </label>
                        <input name="totalCost" id="totalCost" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={((Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0)))} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="dprice" className="form-label"> Delivery Charge </label>
                        <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { dispatch(setDelivery({ price: e.target.value })) } }} name="dprice" id="dprice" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.deliveryDetails?.price || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="pprice" className="form-label"> Pickup Charge </label>
                        <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { dispatch(setPickup({ price: e.target.value })) } }} name="pprice" id="pprice" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.pickupDetails?.price || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="pprice" className="form-label"> Total Rent </label>
                        <input readOnly name="pprice" id="pprice" autoComplete="off" disabled={true} className="form-control input-theme text-uppercase" value={(Number(Number(booking?.totalDays || 0) * (Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0))) + (booking?.point === 0.5 ? Number((Number(booking?.rentalFee || 0) / 2) - (Number(booking?.halfDayOffer || 0))) : 0))} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="securityDeposit" className="form-label"> Security Deposit </label>
                        <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleChange(e) } }} name="securityDeposit" id="securityDeposit" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.securityDeposit || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="advAmount" className="form-label"> Advance Paid </label>
                        <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { dispatch(setAdvance({ amount: e.target.value })) } }} name="advAmount" id="advAmount" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.advance?.amount || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="carId" className="form-label"> Advance Paid Mode </label>
                        <Select
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled={loading}
                            onChange={(selectedOption) => {
                                dispatch(setAdvance({ mode: selectedOption.value }))
                            }}
                            options={[
                                { value: "UPI", label: "UPI" },
                                { value: "Cash", label: "Cash" },
                                { value: "Net Banking", label: "Net Banking" }
                            ]}
                            value={booking?.advance?.mode ? { label: booking?.advance?.mode, value: booking?.advance?.mode } : {}}
                        />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="advRemarks" className="form-label"> Advance Paid Remarks </label>
                        <input onChange={(e) => { dispatch(setAdvance({ remarks: e.target.value })) }} name="advRemarks" id="advRemarks" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.advance?.remarks || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                        <div className="mb-3">
                            <label htmlFor="carId" className="form-label"> Advance Photo </label>
                            <div className="main-div">
                                <div className="btn-div">
                                    <label htmlFor="advPhoto" className="me-2 upload-btn">Upload</label>
                                    <button className="btn-warning btn btn-sm" onClick={() => { if (booking?.advance?.photo) { setChosen(booking?.advance?.photo); setProof(true) } }}>View</button>
                                </div>

                                <input type="file" accept="image/*" className="d-none" name="advPhoto" disabled={loading} id="advPhoto" onChange={(e) => { handleImage(e) }} />
                                <img src={booking?.advance?.photo || White} alt="Advance" className="kycPhotoImg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="balance" className="form-label"> Balance to be Paid </label>
                        <input name="balance" id="balance" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.balancePaid || 0} />
                    </div>
                </div>

            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="carId" className="form-label"> Final Amount </label>
                        <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleChange(e) } }} name="location" id="location" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.totalAmount || 0} />
                    </div>
                </div>
            </div>
            <NextPrev step={2} setStep={setSteps} last={2} onClick={handleNext} loading={loading} />
        </React.Fragment>
    )
}

export default Payment